/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ ⚠️⚠️ TEXT THAT IS ABOUT TO BECOME MARKUP. Five characters, no exceptions. │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * Built on 15 Sep for one caller: a file dropped on a task's description becomes an `<a>` in stored
 * HTML, and the link's text is the **filename somebody uploaded**. A file called
 * `<img src=x onerror=alert(1)>.pdf` is a perfectly legal name on every operating system this
 * product runs on, and writing it into markup unescaped is stored XSS with an upload as the vector.
 *
 * ⚠️⚠️ **THE SERVER SANITISES TOO, AND THAT IS NOT A REASON TO SKIP THIS.** `sanitiseHtml` runs on
 * every description write and would strip the tag — so this is the second of two independent
 * defences, and it is the cheap one. The argument for having both is the one `0026` already makes
 * about the comment path: a sanitiser is a filter with a configuration, and a configuration is a
 * thing somebody widens. Escaping at the point where text becomes markup cannot be widened by
 * accident.
 *
 * ⚠️ **`&` FIRST**, or the escapes escape each other: replacing `<` first turns `&lt;` into
 * `&amp;lt;` on the next pass and the reader sees the literal entity. This is the commonest way a
 * hand-written escaper is wrong, and it is wrong in a way that looks like a rendering bug rather
 * than a security one.
 *
 * ⚠️ **Both quotes**, because the output goes inside an attribute in at least one caller. `'` is
 * `&#39;` rather than `&apos;`: the named entity is XML, and older HTML parsers do not know it.
 */
export function escapeHtml(text: string): string {
  return text
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
}
